/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  newUser: {
    id: "Login.newUser",
    defaultMessage: "Create new account",
  },
  forgotPassword: {
    id: "Login.forgotPassword",
    defaultMessage: "Forgot password?",
  }, 
  loginLabelEmail: {
    id: "Login.Label.Email",
    defaultMessage: "E-Mail",
  },
  loginPlaceholderEmail: {
    id: "Login.Placeholder.Email",
    defaultMessage: "E-Mail",
  },  
  loginErrorEmail: {
    id: "Login.Error.Email",
    defaultMessage: "E-mail is required.",
  }, 
  loginLabelPw: {
    id: "Login.Label.Password",
    defaultMessage: "Password",
  }, 
  loginPlaceholderPw: {
    id: "Login.Placeholder.Password",
    defaultMessage: "Password",
  }, 
  loginErrorPw: {
    id: "Login.Error.Password",
    defaultMessage: "Password is required.",
  }, 
  mustLogin: {
    id: "Login.mustLogin",
    defaultMessage: "To start the configuration, you must log in. If you do not yet have an account, create a new account.",
  }, 
});

export default MESSAGES;